'use strict';

exports.__esModule = true;

exports['default'] = function (propsOrMode) {
  return function wrap(Placeholder) {
    return (0, _HoC2['default'])(Placeholder, propsOrMode);
  };
};

var _HoC = require('./HoC');

var _HoC2 = _interopRequireDefault(_HoC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-hold-animation/lib/Decorator.js
// module id = 198
// module chunks = 0